import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

/**
 * Roles.
 *
 * The sidebar linked to /roles with no route and no component, so it hit the
 * path="*" catch-all and silently landed on the Dashboard. This is that page.
 */
export default function Roles() {
  return (
    <PagedWorkloadPage
      title="Roles" kind="Role" resource="roles"
      label="roles" detail={false} clusterScoped={false}
      cols={['Name', 'Namespace', 'Rules', 'Verbs', 'Resources', 'Age']}
      renderRow={r => [
        <td key="n"><Code>{r.name}</Code></td>,
        <td key="ns" style={{ color: 'var(--ink-2)', fontSize: 13 }}>{r.namespace}</td>,
        <td key="rc">{r.rule_count}</td>,
        <td key="v" style={{ fontSize: 12, color: 'var(--muted)' }}>
          {(r.verbs || []).join(', ') || '—'}
        </td>,
        <td key="rs" style={{ fontSize: 12, color: 'var(--muted)' }}>
          {(r.resources || []).join(', ') || '—'}
        </td>,
        <td key="a"><Age ts={r.created_at} /></td>,
      ]}
    />
  );
}
